export default __webpack_public_path__ + "static/media/warning-logo.88bf7f5f.svg";